/* Rescuevation – SnakE Sprühbalken-Seiten, Runde 3 (rescu-sbx-*), 26.10.2026.
   Basis: rescu-sbp.js (05.10.2026).

   Bewegung ist ADDITIV: Ohne JavaScript, bei reduzierter Bewegung und wenn ein
   Beobachter nie auslöst, steht jedes Element im fertigen Zustand. Das Script legt
   nur einmalige Keyframe-Läufe darüber (Klasse sbx-go, danach wieder entfernt) und
   startet Schleifen nur, solange sie zu sehen sind (Klasse sbx-spielt).
   Canvas-Ebenen (Sprühnebel, Wetline-Luftbild) laufen nur sichtbar und nie bei
   reduzierter Bewegung; das Luftbild zeichnet dann einmal das fertige Bild.

   Preis: Der Shop speichert Netto. Angezeigt wird Netto groß, darunter
   Netto (für die Anzahl) + 19 % MwSt. = Brutto. MwSt. wird je Summe gerundet.

   Anfragen: Jeder Knopf mit data-sbx-angebot füllt im Formular #ContactForm die
   Zeile "Deine Auswahl" (Ausführung, Anzahl, Mitbestellt, Netto/MwSt./Brutto),
   bevor der Anker springt. data-sbx-angebot-text ersetzt die Auswahl (Zubehörkarten). */
(function () {
  'use strict';
  if (window.__rsbx) return;
  window.__rsbx = true;

  var doc = document.documentElement;
  doc.classList.add('sbx-js');

  var ruhig = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hatIO = 'IntersectionObserver' in window;
  var vh = function () { return window.innerHeight || doc.clientHeight; };
  var alle = function (wurzel, sel) { return Array.prototype.slice.call(wurzel.querySelectorAll(sel)); };

  /* ---------- Sprache und Markt (Übersetzung EN/PL, 26.10.2026) ----------
     Sprache aus <html lang>: de, en oder pl (Rückfall de). Markt aus der Währung:
     EUR = Nettopreise im Shop, 19 % MwSt. kommen dazu; PLN = Bruttopreise im Shop,
     23 % VAT enthalten (Netto wird herausgerechnet). Gleiche Regeln wie snippets/rescu-sbx-geld. */

  /* TEXTE-ANFANG (erzeugt von texte.py) */
  var TEXTE = {
    "de": {
      "laeuft": "Wird hinzugefügt …",
      "ok": "Im Warenkorb",
      "fehler": "Das hat nicht geklappt: ",
      "fehler_nochmal": ". Bitte versuche es noch einmal oder ruf uns an.",
      "netto": "netto",
      "brutto": "brutto",
      "mwst": "MwSt.",
      "je_stueck": "je Stück",
      "stueck": "Stück",
      "mengenrabatt": "Mengenrabatt",
      "dazu": "dazu",
      "zubehoer": "mit Zubehör",
      "summe": "Summe",
      "so_gerechnet": "So gerechnet: ",
      "spruehbreite": "Sprühbreite",
      "film": "SnakE® Sprühbalken im Einsatz (Video)"
    },
    "en": {
      "laeuft": "Adding …",
      "ok": "In the cart",
      "fehler": "That did not work: ",
      "fehler_nochmal": ". Please try again or give us a call.",
      "netto": "net",
      "brutto": "gross",
      "mwst": "VAT",
      "je_stueck": "per unit",
      "stueck": "units",
      "mengenrabatt": "volume discount",
      "dazu": "plus",
      "zubehoer": "with accessories",
      "summe": "Total",
      "so_gerechnet": "How it is calculated: ",
      "spruehbreite": "spray width",
      "film": "SnakE® spray bar in action (video)"
    },
    "pl": {
      "laeuft": "Dodawanie …",
      "ok": "W koszyku",
      "fehler": "Nie udało się: ",
      "fehler_nochmal": ". Spróbuj ponownie lub zadzwoń do nas.",
      "netto": "netto",
      "brutto": "brutto",
      "mwst": "VAT",
      "je_stueck": "za sztukę",
      "stueck": "szt.",
      "mengenrabatt": "rabat ilościowy",
      "dazu": "do tego",
      "zubehoer": "z akcesoriami",
      "summe": "Suma",
      "so_gerechnet": "Sposób obliczenia: ",
      "spruehbreite": "szerokości zraszania",
      "film": "Belka zraszająca SnakE® w akcji (wideo)"
    }
  };
  /* TEXTE-ENDE */
  var sprache = String(doc.getAttribute('lang') || (window.Shopify && window.Shopify.locale) || 'de').slice(0, 2).toLowerCase();
  if (!TEXTE[sprache]) sprache = 'de';
  function T(k) { return (TEXTE[sprache] && TEXTE[sprache][k]) || (TEXTE.de && TEXTE.de[k]) || ''; }
  var waehrung = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
  var inkl = waehrung === 'PLN';
  var satz = inkl ? 23 : 19;
  var symbol = waehrung === 'EUR' ? '€' : waehrung === 'PLN' ? 'zł' : waehrung;

  /* ---------- Zahlen ---------- */

  var TS = sprache === 'en' ? ',' : sprache === 'pl' ? ' ' : '.';
  var DS = sprache === 'en' ? '.' : ',';
  function zahl(x, stellen) {
    var s = Math.abs(x).toFixed(stellen).split('.');
    var g = s[0].replace(/\B(?=(\d{3})+(?!\d))/g, TS);
    return (x < 0 && Number(s.join('')) !== 0 ? '−' : '') + g + (stellen ? DS + s[1] : '');
  }
  function format(stellen) { return { format: function (x) { return zahl(x, stellen); } }; }
  var ganzFormat = format(0);
  var einsFormat = format(1);
  var zweiFormat = format(2);
  function euro(cent) {
    var z = zahl(Math.round(cent) / 100, 2);
    return sprache === 'en' && waehrung === 'EUR' ? '€' + z : z + ' ' + symbol;
  }
  /* aus dem Shop-Preis: Netto (PLN: herausgerechnet) und Brutto (EUR: 19 % dazu) */
  function nettoVon(cent) { return inkl ? Math.round(cent * 100 / (100 + satz)) : cent; }
  function bruttoVon(cent) { return inkl ? cent : cent + Math.round(cent * satz / 100); }

  /* ---------- Einblenden ---------- */

  function einmal(el) {
    if (el.__sbxLief) return;
    el.__sbxLief = true;
    el.classList.add('sbx-go');
    var fertig = false;
    var ende = function () {
      if (fertig) return;
      fertig = true;
      el.classList.remove('sbx-go');
    };
    setTimeout(ende, parseInt(el.getAttribute('data-sbx-dauer') || '3400', 10));
  }

  function staffeln(liste) {
    var gruppen = new Map();
    liste.forEach(function (el) {
      var g = el.parentElement;
      var n = gruppen.get(g) || 0;
      if (!el.style.getPropertyValue('--sbx-d')) {
        var d = el.hasAttribute('data-sbx-d') ? parseInt(el.getAttribute('data-sbx-d'), 10) : n * 90;
        el.style.setProperty('--sbx-d', Math.min(d, 700) + 'ms');
      }
      gruppen.set(g, n + 1);
    });
  }

  function imBild(el) {
    var r = el.getBoundingClientRect();
    return r.top < vh() - 40 && r.bottom > 0;
  }

  function einblenden(wurzel) {
    if (ruhig || !hatIO) return;
    var els = alle(wurzel, '[data-sbx-in]');
    staffeln(els);
    var io = new IntersectionObserver(function (eintraege) {
      eintraege.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        einmal(e.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0 });
    els.forEach(function (el) {
      if (el.hasAttribute('data-sbx-sofort')) { einmal(el); return; }
      if (imBild(el)) return; /* was beim Laden schon zu sehen ist, bleibt ruhig */
      io.observe(el);
    });
    /* Linien, Strecken und Zeichnungen laufen einmal, sobald sie ins Bild kommen */
    alle(wurzel, '[data-sbx-linie], [data-sbx-strecke], [data-sbx-zeichnung]').forEach(function (el) {
      if (imBild(el) && !el.hasAttribute('data-sbx-zeichnung')) return;
      var io2 = new IntersectionObserver(function (e) {
        if (!e[0].isIntersecting) return;
        io2.disconnect();
        einmal(el);
      }, { rootMargin: '0px 0px -18% 0px' });
      io2.observe(el);
    });
    alle(wurzel, '[data-sbx-buehne]').forEach(function (el) { einmal(el); });
  }

  /* ---------- Schleifen nur, solange sichtbar ---------- */

  var spielHoerer = [];
  function schleifen(wurzel) {
    if (ruhig || !hatIO) return;
    var io = new IntersectionObserver(function (eintraege) {
      eintraege.forEach(function (e) {
        e.target.classList.toggle('sbx-spielt', e.isIntersecting);
        spielHoerer.forEach(function (h) { if (h.el === e.target) h.fn(e.isIntersecting); });
      });
    }, { threshold: 0.08 });
    alle(wurzel, '[data-sbx-spiel], [data-sbx-strecke], [data-sbx-film], [data-sbx-zeichnung], [data-sbx-kauf]').forEach(function (el) { io.observe(el); });
  }
  function beiSichtbar(el, fn) { spielHoerer.push({ el: el, fn: fn }); }

  /* ---------- Kennzahlen zählen einmal hoch ---------- */

  function zaehlen(wurzel) {
    if (ruhig || !hatIO) return;
    var io = new IntersectionObserver(function (eintraege) {
      eintraege.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        var el = e.target;
        var roh = String(el.getAttribute('data-sbx-zahl')).trim();
        var endText = el.textContent;
        var treffer = roh.match(/^(\d+)(?:,(\d+))?$/);
        if (!treffer) return;
        var stellen = treffer[2] ? treffer[2].length : 0;
        var ziel = parseFloat(roh.replace(',', '.'));
        if (!(ziel > 0)) return;
        var fmt = format(stellen);
        var t0 = null;
        var schritt = function (t) {
          if (!t0) t0 = t;
          var p = Math.min(1, (t - t0) / 1500);
          var w = 1 - Math.pow(1 - p, 4);
          el.textContent = fmt.format(ziel * w);
          if (p < 1) requestAnimationFrame(schritt); else el.textContent = endText;
        };
        requestAnimationFrame(schritt);
      });
    }, { rootMargin: '0px 0px -12% 0px' });
    alle(wurzel, '[data-sbx-zahl]').forEach(function (el) { io.observe(el); });
  }

  /* ---------- Warenkorb ---------- */

  function inDenWarenkorb(items) {
    var schublade = document.querySelector('cart-drawer');
    var body = { items: items };
    if (schublade && typeof schublade.getSectionsToRender === 'function') {
      body.sections = schublade.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().then(function (daten) {
        if (!res.ok || daten.status) throw new Error(daten.description || daten.message || 'HTTP ' + res.status);
        return daten;
      });
    }).then(function (daten) {
      if (schublade && typeof schublade.renderContents === 'function' && daten.sections) {
        schublade.classList.remove('is-empty');
        schublade.renderContents(daten);
      } else {
        window.location.href = root + 'cart';
      }
      return daten;
    });
  }

  function knopfLaeuft(btn, an) {
    if (!btn) return;
    if (an) {
      if (!btn.__sbxLabel) btn.__sbxLabel = btn.innerHTML;
      btn.setAttribute('aria-busy', 'true');
      btn.disabled = true;
      btn.innerHTML = '<span>' + T('laeuft') + '</span>';
    } else {
      btn.removeAttribute('aria-busy');
      btn.disabled = false;
      if (btn.__sbxLabel) btn.innerHTML = btn.__sbxLabel;
    }
  }

  function knopfOk(btn) {
    if (!btn) return;
    var label = btn.__sbxLabel || btn.innerHTML;
    btn.removeAttribute('aria-busy');
    btn.disabled = false;
    btn.classList.add('ist-ok');
    btn.innerHTML = '<svg class="sbx-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.2 4.2L19 7"/></svg><span>' + T('ok') + '</span>';
    setTimeout(function () { btn.classList.remove('ist-ok'); btn.innerHTML = label; }, 2400);
  }

  function fehler(bereich, text) {
    var f = bereich && bereich.querySelector('[data-sbx-fehler]');
    if (!f) return;
    if (!text) { f.hidden = true; f.textContent = ''; return; }
    f.hidden = false;
    f.textContent = text;
  }

  /* ---------- Stepper ---------- */

  function stepper(wurzel) {
    alle(wurzel, '[data-sbx-stepper]').forEach(function (st) {
      var feld = st.querySelector('input');
      var setzen = function (n) {
        var min = parseInt(feld.min || '1', 10), max = parseInt(feld.max || '99', 10);
        n = Math.max(min, Math.min(max, n || min));
        feld.value = n;
        feld.dispatchEvent(new Event('change', { bubbles: true }));
      };
      st.querySelector('[data-sbx-minus]').addEventListener('click', function () { setzen(parseInt(feld.value, 10) - 1); });
      st.querySelector('[data-sbx-plus]').addEventListener('click', function () { setzen(parseInt(feld.value, 10) + 1); });
      feld.addEventListener('blur', function () { setzen(parseInt(feld.value, 10)); });
    });
  }

  /* ---------- Galerie ---------- */

  function galerie(wurzel) {
    alle(wurzel, '[data-sbx-galerie]').forEach(function (g) {
      var band = g.querySelector('[data-sbx-band]');
      var minis = alle(g, '[data-sbx-mini]');
      if (!band || !minis.length) return;
      var bilder = alle(band, '.sbx-galerie__bild');
      var aktiv = function (i) { minis.forEach(function (m, k) { m.setAttribute('aria-current', k === i ? 'true' : 'false'); }); };
      minis.forEach(function (m, i) {
        m.addEventListener('click', function () {
          var ziel = bilder[i];
          if (!ziel) return;
          band.scrollTo({ left: ziel.offsetLeft - band.offsetLeft, behavior: ruhig ? 'auto' : 'smooth' });
          aktiv(i);
        });
      });
      var geplant = false;
      band.addEventListener('scroll', function () {
        if (geplant) return;
        geplant = true;
        requestAnimationFrame(function () {
          geplant = false;
          var i = Math.round(band.scrollLeft / Math.max(1, band.clientWidth));
          aktiv(Math.max(0, Math.min(minis.length - 1, i)));
        });
      }, { passive: true });
    });
  }

  /* ---------- Auswahl: was gerade im Kopf gewählt ist ---------- */

  var kaufForm = null;
  var stand = null; /* { titel, voll, preis, n, extra, namen, netto, mwst, brutto, items } */

  function lesen(form) {
    var radios = alle(form, '[data-sbx-variante]');
    var r = radios.filter(function (x) { return x.checked || x.type === 'hidden'; })[0] || radios[0];
    var n = Math.max(1, parseInt((form.querySelector('[data-sbx-anzahl]') || {}).value, 10) || 1);
    var p = parseInt(r.getAttribute('data-preis'), 10) || 0;
    var vergleich = parseInt(r.getAttribute('data-vergleich'), 10) || 0;
    var handle = r.getAttribute('data-handle') || '';
    var items = [{ id: parseInt(r.value, 10), quantity: n }];
    var extra = 0, namen = [];
    var kopf = form.closest('[data-sbx-kauf]') || form;
    alle(kopf, '[data-sbx-addon]').forEach(function (a) {
      var label = a.closest('.sbx-addon');
      var weg = label && label.getAttribute('data-ausser') && label.getAttribute('data-ausser') === handle;
      if (label) label.classList.toggle('ist-weg', !!weg);
      if (a.checked && !weg) {
        extra += parseInt(a.getAttribute('data-preis'), 10) || 0;
        namen.push(a.getAttribute('data-titel'));
        items.push({ id: parseInt(a.value, 10), quantity: 1 });
      }
    });
    /* Mengenrabatt: gilt für die Ausführung (data-staffel) ab staffelAb Stück, nur auf das Hauptprodukt */
    var ab = parseInt(kopf.getAttribute('data-staffel-ab'), 10) || 0;
    var proz = parseFloat(kopf.getAttribute('data-staffel-prozent')) || 0;
    var staffelFaehig = ab > 0 && proz > 0 && r.getAttribute('data-staffel') === 'true';
    /* wie Shopify: Rabatt je Stück gerundet, dann mal Anzahl (3 × 133,61 € = 400,83 €) */
    var staffel = staffelFaehig && n >= ab ? Math.round(p * proz / 100) * n : 0;
    /* Summe in Shop-Preisen; EUR: Netto, 19 % dazu; PLN: Brutto, 23 % darin */
    var summe = p * n - staffel + extra;
    var netto = nettoVon(summe);
    var brutto = bruttoVon(summe);
    var mwst = brutto - netto;
    return {
      radio: r, handle: handle, pk: r.getAttribute('data-pk') || '',
      titel: r.getAttribute('data-titel') || '', voll: r.getAttribute('data-voll') || '',
      info: r.getAttribute('data-info'), verfuegbar: r.getAttribute('data-verfuegbar') === 'true',
      preis: p, vergleich: vergleich, n: n, extra: extra, namen: namen,
      staffel: staffel, staffelFaehig: staffelFaehig, staffelAb: ab, staffelProzent: proz,
      netto: netto, mwst: mwst, brutto: brutto, items: items
    };
  }

  function auswahlText(s) {
    var t = s.n + ' × ' + (s.voll || s.titel) + ' (' + euro(nettoVon(s.preis)) + ' ' + T('netto') + ' ' + T('je_stueck') + ')';
    if (s.staffel > 0) t += ', ' + T('mengenrabatt') + ' ' + prozentText(s.staffelProzent) + ' (−' + euro(nettoVon(s.staffel)) + ')';
    if (s.namen.length) t += ', ' + T('dazu') + ': ' + s.namen.join(', ');
    return t;
  }

  function prozentText(p) {
    var z = String(p).replace('.', DS);
    return sprache === 'de' ? z + '\u00a0%' : z + '%';
  }

  function setzeText(sel, text, puls) {
    alle(document, sel).forEach(function (el) {
      if (el.textContent === text) return;
      el.textContent = text;
      if (puls && !ruhig) { el.classList.remove('sbx-puls'); void el.offsetWidth; el.classList.add('sbx-puls'); }
    });
  }

  function anzeigen(s, puls) {
    setzeText('[data-sbx-netto]', euro(nettoVon(s.preis)), puls);
    setzeText('[data-sbx-b-netto]', euro(s.netto), puls);
    setzeText('[data-sbx-b-mwst]', euro(s.mwst), puls);
    setzeText('[data-sbx-b-brutto]', euro(s.brutto), puls);
    var menge = s.n > 1 ? ' · ' + s.n + ' ' + T('stueck') : '';
    if (s.staffel > 0) menge += ' · −' + prozentText(s.staffelProzent);
    if (s.extra > 0) menge += ' · ' + T('zubehoer');
    alle(document, '[data-sbx-staffel]').forEach(function (el) { el.hidden = !(s.staffel > 0); });
    alle(document, '[data-sbx-staffel-hinweis]').forEach(function (el) { el.hidden = !s.staffelFaehig; });
    if (s.staffel > 0) setzeText('[data-sbx-staffel-betrag]', '−' + euro(nettoVon(s.staffel)), puls);
    setzeText('[data-sbx-b-menge]', menge, false);
    alle(document, '[data-sbx-je]').forEach(function (el) { el.hidden = !(s.n > 1 || s.extra > 0); });
    /* Rabatt: nur mit Vergleichspreis über dem Preis; Ersparnis für die gewählte Anzahl */
    var rabatt = s.vergleich > s.preis;
    alle(document, '[data-sbx-rabatt]').forEach(function (el) { el.hidden = !rabatt; });
    alle(document, '[data-sbx-sticky-alt]').forEach(function (el) { el.hidden = !rabatt; });
    alle(document, '[data-sbx-rabatt-box]').forEach(function (el) { el.classList.toggle('hat-rabatt', rabatt); });
    if (rabatt) {
      setzeText('[data-sbx-alt]', euro(nettoVon(s.vergleich)), false);
      setzeText('[data-sbx-spar]', euro(nettoVon(s.vergleich - s.preis) * s.n), puls);
      setzeText('[data-sbx-prozent]', String(Math.round((s.vergleich - s.preis) / s.vergleich * 100)), false);
      alle(document, '[data-sbx-sticky-alt]').forEach(function (el) {
        var z = el.lastChild;
        if (z && z.nodeType === 3) z.textContent = euro(nettoVon(s.vergleich));
      });
    }
    setzeText('[data-sbx-sticky-titel]', s.titel, false);
    setzeText('[data-sbx-sticky-preis]', euro(nettoVon(s.preis)), false);
    setzeText('[data-sbx-sticky-brutto]', euro(bruttoVon(s.preis)), false);
    /* Anfrage-Formular spiegelt die Auswahl schon beim Wählen */
    setzeText('[data-sbx-a-text]', auswahlText(s), false);
    setzeText('[data-sbx-a-netto]', euro(s.netto), false);
    setzeText('[data-sbx-a-mwst]', euro(s.mwst), false);
    setzeText('[data-sbx-a-brutto]', euro(s.brutto), false);
    alle(document, '[data-sbx-f="auswahl"]').forEach(function (f) {
      f.value = auswahlText(s) + ' · ' + T('summe') + ' ' + euro(s.netto) + ' ' + T('netto') + ' + ' + euro(s.mwst) + ' ' + T('mwst') + ' = ' + euro(s.brutto) + ' ' + T('brutto');
    });
    /* Lieferumfang folgt der gewählten Ausführung */
    if (s.pk) {
      alle(document, '[data-nur]').forEach(function (li) {
        var nur = li.getAttribute('data-nur');
        if (!nur) return;
        /* setAttribute statt .hidden: gilt auch für SVG-Gruppen in der Zeichnung */
        if (nur.indexOf(s.pk) === -1) li.setAttribute('hidden', ''); else li.removeAttribute('hidden');
      });
    }
  }

  function kauf(wurzel) {
    alle(wurzel, '[data-sbx-kauf]').forEach(function (bereich) {
      var form = bereich.querySelector('[data-sbx-form]');
      if (!form) return;
      kaufForm = form;
      var infoEl = bereich.querySelector('[data-sbx-info]');
      var btn = form.querySelector('[data-sbx-submit]');
      var anzahl = form.querySelector('[data-sbx-anzahl]');

      function rechnen(puls) {
        stand = lesen(form);
        anzeigen(stand, puls);
        if (infoEl && stand.info != null) infoEl.textContent = stand.info;
        if (btn) btn.disabled = !stand.verfuegbar;
      }

      alle(form, '[data-sbx-variante]').forEach(function (r) { r.addEventListener('change', function () { rechnen(true); }); });
      alle(bereich, '[data-sbx-addon]').forEach(function (a) { a.addEventListener('change', function () { rechnen(true); }); });
      if (anzahl) {
        anzahl.addEventListener('change', function () { rechnen(true); });
        anzahl.addEventListener('input', function () { rechnen(false); });
      }
      rechnen(false);

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        fehler(bereich, '');
        knopfLaeuft(btn, true);
        inDenWarenkorb(lesen(form).items).then(function () {
          knopfOk(btn);
        }).catch(function (err) {
          knopfLaeuft(btn, false);
          fehler(bereich, T('fehler') + err.message + T('fehler_nochmal'));
        });
      });
    });
  }

  /* ---------- Angebot anfordern: Auswahl ins Formular, dann springen ---------- */

  function angebot(wurzel) {
    alle(wurzel, '[data-sbx-angebot]').forEach(function (a) {
      a.addEventListener('click', function () {
        var eigen = a.getAttribute('data-sbx-angebot-text');
        if (eigen) {
          setzeText('[data-sbx-a-text]', eigen, false);
          alle(document, '[data-sbx-a-summe]').forEach(function (el) { el.hidden = true; });
          alle(document, '[data-sbx-f="auswahl"]').forEach(function (f) { f.value = eigen; });
        } else if (kaufForm) {
          stand = lesen(kaufForm);
          anzeigen(stand, false);
          alle(document, '[data-sbx-a-summe]').forEach(function (el) { el.hidden = false; });
        }
        var anliegen = a.getAttribute('data-sbx-anliegen') || 'Angebot';
        alle(document, '[data-sbx-f="anliegen"]').forEach(function (sel) {
          for (var i = 0; i < sel.options.length; i++) if (sel.options[i].value.indexOf(anliegen) === 0) { sel.selectedIndex = i; break; }
          sel.dispatchEvent(new Event('change', { bubbles: true }));
        });
        var feld = document.querySelector('#ContactForm [data-sbx-f="mail"]');
        if (feld) setTimeout(function () { try { feld.focus({ preventScroll: true }); } catch (err) { feld.focus(); } }, ruhig ? 0 : 650);
      });
    });
  }

  /* ---------- Anfrage: Knopftext folgt dem Anliegen ---------- */

  function anliegen(wurzel) {
    alle(wurzel, '[data-sbx-f="anliegen"]').forEach(function (sel) {
      var form = sel.closest('form');
      var label = form && form.querySelector('[data-sbx-submit-label]');
      if (!label) return;
      var standard = label.textContent;
      sel.addEventListener('change', function () {
        var o = sel.options[sel.selectedIndex];
        label.textContent = (o && o.getAttribute('data-knopf')) || standard;
      });
    });
  }

  /* ---------- Zubehör und "alles zusammen" ---------- */

  function zufuegen(wurzel) {
    alle(wurzel, '[data-sbx-add]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        var liste;
        try { liste = JSON.parse(btn.getAttribute('data-sbx-add')); } catch (err) { return; }
        var items = liste.map(function (x) { return { id: x.id, quantity: x.q || 1 }; });
        if (!items.length) return;
        e.preventDefault();
        var kasten = btn.closest('.sbx-karte__inhalt, .sbx-alles, .sbx-upgrade__inhalt, .sbx-band__aktion') || btn.parentElement;
        fehler(kasten, '');
        knopfLaeuft(btn, true);
        inDenWarenkorb(items).then(function () { knopfOk(btn); }).catch(function (err) {
          knopfLaeuft(btn, false);
          fehler(kasten, T('fehler') + err.message + '.');
        });
      });
    });
    /* Warenkorb-Knöpfe außerhalb des Kopfs legen die Auswahl aus dem Kopf ab */
    alle(wurzel, '[data-sbx-korb]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        if (!kaufForm) return;
        e.preventDefault();
        var kasten = btn.closest('.sbx-band__aktion, .sbx-sticky, .sbx-entfalten__aktion, .sbx-rechner__cta') || btn.parentElement;
        fehler(kasten, '');
        knopfLaeuft(btn, true);
        inDenWarenkorb(lesen(kaufForm).items).then(function () { knopfOk(btn); }).catch(function (err) {
          knopfLaeuft(btn, false);
          fehler(kasten, T('fehler') + err.message + '.');
        });
      });
    });
  }

  /* ---------- Sprühnebel über dem Bühnenfoto ---------- */

  function sprite(rgb) {
    var c = document.createElement('canvas');
    c.width = c.height = 64;
    var x = c.getContext('2d');
    var g = x.createRadialGradient(32, 32, 0, 32, 32, 32);
    g.addColorStop(0, 'rgba(' + rgb + ',1)');
    g.addColorStop(0.35, 'rgba(' + rgb + ',0.55)');
    g.addColorStop(1, 'rgba(' + rgb + ',0)');
    x.fillStyle = g;
    x.fillRect(0, 0, 64, 64);
    return c;
  }

  function nebel(wurzel) {
    if (ruhig) return;
    alle(wurzel, '[data-sbx-nebel]').forEach(function (cv) {
      var fig = cv.closest('[data-sbx-buehne]');
      var img = fig && fig.querySelector('img');
      if (!fig || !img || !cv.getContext) return;
      var duesen = (fig.getAttribute('data-duesen') || '').split(';').map(function (d) {
        var t = d.split(',').map(function (x) { return parseFloat(x); });
        return t.length >= 2 && !isNaN(t[0]) ? { x: t[0] / 100, y: t[1] / 100, w: (isNaN(t[2]) ? 90 : t[2]) * Math.PI / 180 } : null;
      }).filter(Boolean);
      if (!duesen.length) return;
      var art = fig.getAttribute('data-art') || 'hell';
      var nacht = art === 'nacht';
      var bw = parseFloat(fig.getAttribute('data-bw')) || 1, bh = parseFloat(fig.getAttribute('data-bh')) || 1;
      var fokus = (fig.getAttribute('data-fokus') || '50% 50%').split(/\s+/).map(function (v) { return (parseFloat(v) || 50) / 100; });
      var ctx = cv.getContext('2d');
      var weiss = sprite('255,255,255');
      var warm = sprite('255,247,214');
      var dpr = Math.min(window.devicePixelRatio || 1, 1.5);
      var W = 0, H = 0, skala = 1, ox = 0, oy = 0;
      var teile = [];
      var laeuft = false, sichtbar = false, letzte = 0, raf = 0;

      function messen() {
        var r = fig.getBoundingClientRect();
        W = r.width; H = r.height;
        cv.width = Math.round(W * dpr); cv.height = Math.round(H * dpr);
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        if (fig.getAttribute('data-fit') === 'box') {
          /* eingepasstes Foto: die Bildfläche ist das img selbst */
          var ib = img.getBoundingClientRect();
          skala = ib.width / bw;
          ox = ib.left - r.left;
          oy = ib.top - r.top;
          return;
        }
        /* object-fit: cover mit object-position */
        skala = Math.max(W / bw, H / bh);
        ox = (W - bw * skala) * fokus[0];
        oy = (H - bh * skala) * fokus[1];
      }

      function erzeugen(d, dt) {
        var px = ox + d.x * bw * skala, py = oy + d.y * bh * skala;
        var gross = bh * skala;
        var rate = nacht ? 34 : 46; /* Teilchen je Sekunde und Düse */
        var anz = rate * dt + Math.random();
        for (var i = 0; i < Math.floor(anz); i++) {
          var tropfen = Math.random() < (nacht ? 0.35 : 0.6);
          var streu = (nacht ? 0.55 : 0.42) * (Math.random() - 0.5) * 2;
          var w = d.w + streu;
          var v = gross * (tropfen ? (0.32 + Math.random() * 0.28) : (0.1 + Math.random() * 0.14));
          teile.push({
            x: px + (Math.random() - 0.5) * 4, y: py,
            vx: Math.cos(w) * v, vy: Math.sin(w) * v,
            t: 0, dauer: tropfen ? 0.55 + Math.random() * 0.45 : (nacht ? 2.2 : 1.6) + Math.random() * 1.4,
            r0: tropfen ? 0.7 + Math.random() * 1.1 : gross * (nacht ? 0.012 : 0.008),
            r1: tropfen ? 1.2 + Math.random() * 1.4 : gross * (nacht ? 0.09 : 0.055) * (0.6 + Math.random() * 0.8),
            a: tropfen ? (nacht ? 0.5 : 0.62) : (nacht ? 0.075 : 0.06),
            tropfen: tropfen,
            warm: nacht && Math.random() < 0.4
          });
        }
      }

      function bild(t) {
        if (!laeuft) return;
        var dt = Math.min(0.05, (t - (letzte || t)) / 1000);
        letzte = t;
        ctx.clearRect(0, 0, W, H);
        duesen.forEach(function (d) { erzeugen(d, dt); });
        var gross = bh * skala;
        var g = gross * 0.9;
        var neu = [];
        for (var i = 0; i < teile.length; i++) {
          var p = teile[i];
          p.t += dt;
          if (p.t >= p.dauer) continue;
          var k = p.t / p.dauer;
          if (p.tropfen) { p.vy += g * dt; p.vx *= 0.985; p.vy *= 0.985; }
          else { p.vx *= 0.96; p.vy *= 0.955; p.vy -= gross * 0.004 * dt; p.vx += (Math.random() - 0.5) * gross * 0.02 * dt; }
          p.x += p.vx * dt; p.y += p.vy * dt;
          var r = p.r0 + (p.r1 - p.r0) * Math.sqrt(k);
          var a = p.a * (k < 0.15 ? k / 0.15 : 1 - (k - 0.15) / 0.85);
          ctx.globalAlpha = Math.max(0, a);
          ctx.drawImage(p.warm ? warm : weiss, p.x - r, p.y - r, r * 2, r * 2);
          neu.push(p);
        }
        ctx.globalAlpha = 1;
        teile = neu.length > 1400 ? neu.slice(neu.length - 1400) : neu;
        raf = requestAnimationFrame(bild);
      }

      function start() {
        if (laeuft || !sichtbar || document.hidden) return;
        laeuft = true; letzte = 0;
        raf = requestAnimationFrame(bild);
      }
      function halt() {
        laeuft = false;
        cancelAnimationFrame(raf);
      }

      messen();
      if ('ResizeObserver' in window) new ResizeObserver(function () { messen(); }).observe(fig);
      else window.addEventListener('resize', messen);
      beiSichtbar(fig, function (an) { sichtbar = an; if (an) start(); else halt(); });
      document.addEventListener('visibilitychange', function () { if (document.hidden) halt(); else start(); });
    });
  }

  /* ---------- Wetline-Rechner mit Luftbild ---------- */

  var SKALA = [100, 250, 500, 750, 1000, 1500, 2000, 3000, 5000, 7500, 10000, 15000, 20000, 30000];

  function meter(m) { return m >= 1000 ? (m % 1000 === 0 ? ganzFormat.format(m / 1000) : einsFormat.format(m / 1000)) + ' km' : ganzFormat.format(m) + ' m'; }

  function luftbild(r, werte) {
    var cv = r.querySelector('[data-sbx-luftbild]');
    if (!cv || !cv.getContext) return null;
    var ctx = cv.getContext('2d');
    var dunkel = r.classList.contains('sbx--navy') || r.classList.contains('sbx--kino');
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var W = 0, H = 0;
    var halme = [];
    var feuer = [];
    var laeuft = false, sichtbar = false, raf = 0, t0 = 0;
    var DAUER = 6200;
    var zaehler = r.querySelector('[data-sbx-r-live]');

    function messen() {
      var b = cv.getBoundingClientRect();
      W = b.width; H = b.height;
      cv.width = Math.round(W * dpr); cv.height = Math.round(H * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      halme = [];
      var s = 7;
      var zufall = function () { s = (s * 9301 + 49297) % 233280; return s / 233280; };
      feuer = [];
      for (var k = 0; k < Math.ceil(W / 14); k++) feuer.push({ x: k * 14 + zufall() * 8, p: zufall() * 6.28, h: 0.6 + zufall() * 0.6 });
    }



    function rund(x, y, w, h, r) {
      ctx.beginPath();
      if (ctx.roundRect) ctx.roundRect(x, y, w, h, r); else ctx.rect(x, y, w, h);
    }

    function zeichnen(fort, zeit) {
      var w = werte();
      var tt = zeit != null ? zeit / 1000 : 0;
      ctx.clearRect(0, 0, W, H);
      /* Kartengrund: feines Punktraster */
      ctx.fillStyle = dunkel ? 'rgba(255,255,255,0.09)' : 'rgba(18,18,18,0.09)';
      for (var gy = 10; gy < H; gy += 18) for (var gx = 10; gx < W; gx += 18) ctx.fillRect(gx, gy, 1.5, 1.5);

      var y = H * 0.66;
      var band = Math.max(18, H * 0.17);
      var x0 = W * 0.05, x1 = W * 0.86;
      var xf = x0 + (x1 - x0) * fort;

      /* Entfernungsmarken unten */
      ctx.font = '600 11px ' + getComputedStyle(cv).fontFamily;
      ctx.textAlign = 'center';
      for (var m = 0; m <= 4; m++) {
        var mx = x0 + (x1 - x0) * m / 4;
        ctx.fillStyle = dunkel ? 'rgba(255,255,255,0.35)' : 'rgba(18,18,18,0.3)';
        ctx.fillRect(mx, y + band / 2 + 8, 1, 6);
        ctx.fillStyle = dunkel ? 'rgba(255,255,255,0.6)' : 'rgba(18,18,18,0.55)';
        ctx.fillText(ganzFormat.format(Math.round(w.laenge * m / 4)) + ' m', mx, y + band / 2 + 26);
      }

      /* Wetline: Deckkraft folgt den Litern je m² */
      var dichte = Math.max(0.35, Math.min(0.9, w.lqm / 1.3));
      var g = ctx.createLinearGradient(0, y - band / 2, 0, y + band / 2);
      g.addColorStop(0, 'rgba(42,183,202,0)');
      g.addColorStop(0.16, 'rgba(42,183,202,' + (dichte * 0.8).toFixed(3) + ')');
      g.addColorStop(0.5, 'rgba(23,130,143,' + dichte.toFixed(3) + ')');
      g.addColorStop(0.84, 'rgba(42,183,202,' + (dichte * 0.8).toFixed(3) + ')');
      g.addColorStop(1, 'rgba(42,183,202,0)');
      ctx.fillStyle = g;
      ctx.fillRect(x0, y - band / 2, Math.max(0, xf - x0), band);
      if (zeit != null && xf > x0 + 40) {
        var sx = x0 + ((tt * 140) % Math.max(1, xf - x0 - 30));
        var sg = ctx.createLinearGradient(sx, 0, sx + 60, 0);
        sg.addColorStop(0, 'rgba(255,255,255,0)'); sg.addColorStop(0.5, 'rgba(255,255,255,0.28)'); sg.addColorStop(1, 'rgba(255,255,255,0)');
        ctx.fillStyle = sg;
        ctx.fillRect(sx, y - band * 0.32, 60, band * 0.64);
      }

      /* Brandfront: gezackte Flammenkante mit Glut, dahinter verbrannte Fläche.
         Sie rückt an und hält an der Wetline. */
      var stopp = y - band / 2 - 14;
      var fy = H * 0.12 + (stopp - H * 0.12) * Math.min(1, fort * 1.12);
      var kante = [];
      for (var kx = -10, k = 0; kx <= W + 14; kx += 12, k++) {
        var spitze = (k % 2 ? 1 : -0.35) * (5 + 4 * Math.sin(tt * 6 + k * 1.7));
        kante.push([kx, fy - spitze + Math.sin(kx * 0.02 + tt * 1.4) * 3]);
      }
      ctx.beginPath();
      ctx.moveTo(-10, -10);
      kante.forEach(function (p) { ctx.lineTo(p[0], p[1]); });
      ctx.lineTo(W + 14, -10);
      ctx.closePath();
      var asche = ctx.createLinearGradient(0, 0, 0, fy);
      asche.addColorStop(0, dunkel ? 'rgba(18,18,18,0.55)' : 'rgba(18,18,18,0.2)');
      asche.addColorStop(1, dunkel ? 'rgba(18,18,18,0.35)' : 'rgba(18,18,18,0.1)');
      ctx.fillStyle = asche;
      ctx.fill();
      var flamme = ctx.createLinearGradient(0, fy - 34, 0, fy + 6);
      flamme.addColorStop(0, 'rgba(178,17,14,0)');
      flamme.addColorStop(0.6, 'rgba(178,17,14,0.7)');
      flamme.addColorStop(1, 'rgba(245,215,0,0.9)');
      ctx.beginPath();
      kante.forEach(function (p, i) { if (i === 0) ctx.moveTo(p[0], p[1] - 30); else ctx.lineTo(p[0], p[1] - 30 - (i % 2) * 8); });
      for (var i2 = kante.length - 1; i2 >= 0; i2--) ctx.lineTo(kante[i2][0], kante[i2][1]);
      ctx.closePath();
      ctx.fillStyle = flamme;
      ctx.fill();
      ctx.save();
      ctx.shadowColor = 'rgba(245,215,0,0.9)';
      ctx.shadowBlur = 10;
      ctx.strokeStyle = 'rgba(245,215,0,0.95)';
      ctx.lineWidth = 2;
      ctx.beginPath();
      kante.forEach(function (p, i) { if (i === 0) ctx.moveTo(p[0], p[1]); else ctx.lineTo(p[0], p[1]); });
      ctx.stroke();
      ctx.restore();
      if (zeit != null) {
        for (var f = 0; f < feuer.length; f++) {
          var fl = feuer[f];
          var steig = (tt * 34 * fl.h + fl.p * 30) % 38;
          ctx.globalAlpha = Math.max(0, 0.85 - steig / 38);
          ctx.fillStyle = f % 3 ? '#f5d700' : '#b2110e';
          ctx.fillRect(fl.x + Math.sin(tt * 3 + fl.p) * 3, fy - 12 - steig, 2, 2);
        }
        ctx.globalAlpha = 1;
      }

      /* Fahrzeug von oben, fährt nach rechts: Aufbau, Fahrerhaus, Blaulicht, Sprühbalken vorn */
      var lang = band * 2.3, breit = band * 0.86;
      ctx.save();
      ctx.translate(xf, y);
      if (zeit != null && fort < 1) {
        var fan = ctx.createLinearGradient(0, 0, band * 0.9, 0);
        fan.addColorStop(0, 'rgba(255,255,255,0.55)');
        fan.addColorStop(1, 'rgba(255,255,255,0)');
        ctx.fillStyle = fan;
        ctx.beginPath();
        ctx.moveTo(6, -band * 0.5); ctx.lineTo(band * 0.9, -band * 0.62); ctx.lineTo(band * 0.9, band * 0.62); ctx.lineTo(6, band * 0.5);
        ctx.closePath(); ctx.fill();
      }
      ctx.fillStyle = 'rgba(0,0,0,0.25)';
      rund(-lang + 3, -breit / 2 + 4, lang, breit, 4); ctx.fill();
      ctx.fillStyle = '#b2110e';
      rund(-lang, -breit / 2, lang * 0.74, breit, 3); ctx.fill();
      ctx.fillStyle = 'rgba(255,255,255,0.22)';
      for (var r2 = 1; r2 < 4; r2++) ctx.fillRect(-lang + r2 * lang * 0.18, -breit / 2 + 3, 1.5, breit - 6);
      ctx.fillStyle = '#971110';
      rund(-lang * 0.25, -breit / 2, lang * 0.25, breit, 3); ctx.fill();
      ctx.fillStyle = 'rgba(255,255,255,0.85)';
      ctx.fillRect(-lang * 0.07, -breit * 0.38, lang * 0.045, breit * 0.76);
      var an = Math.floor(tt * 5) % 2 === 0;
      ctx.fillStyle = an ? '#2ab7ca' : 'rgba(42,183,202,0.35)';
      ctx.fillRect(-lang * 0.2, -breit * 0.36, 5, breit * 0.3);
      ctx.fillStyle = an ? 'rgba(42,183,202,0.35)' : '#2ab7ca';
      ctx.fillRect(-lang * 0.2, breit * 0.06, 5, breit * 0.3);
      ctx.fillStyle = '#f5d700';
      rund(2, -band * 0.52, 5, band * 1.04, 2); ctx.fill();
      ctx.fillStyle = '#121212';
      for (var dz = 0; dz < 4; dz++) ctx.fillRect(7, -band * 0.4 + dz * band * 0.267, 3, 3);
      ctx.restore();
    }

    function bild(t) {
      if (!laeuft) return;
      if (!t0) t0 = t;
      var w = werte();
      var p = Math.min(1, (t - t0) / DAUER);
      var e = 1 - Math.pow(1 - p, 2.2);
      zeichnen(e, t);
      if (zaehler) zaehler.textContent = ganzFormat.format(Math.round(w.laenge * e));
      if (p >= 1 && t - t0 > DAUER + 2600) t0 = t; /* kurz stehen lassen, dann neu fahren */
      raf = requestAnimationFrame(bild);
    }

    function start() {
      if (laeuft || !sichtbar || document.hidden) return;
      laeuft = true;
      raf = requestAnimationFrame(bild);
    }
    function halt() { laeuft = false; cancelAnimationFrame(raf); }

    messen();
    if ('ResizeObserver' in window) new ResizeObserver(function () { messen(); if (!laeuft) zeichnen(1, null); }).observe(cv);
    r.classList.add('ist-luftbild');
    zeichnen(1, null);
    if (zaehler) zaehler.textContent = ganzFormat.format(Math.round(werte().laenge));
    if (!ruhig) {
      beiSichtbar(r, function (an) { sichtbar = an; if (an) start(); else halt(); });
      document.addEventListener('visibilitychange', function () { if (document.hidden) halt(); else start(); });
    }
    return {
      neu: function () {
        if (ruhig || !laeuft) { zeichnen(1, null); if (zaehler) zaehler.textContent = ganzFormat.format(Math.round(werte().laenge)); return; }
        t0 = 0;
      }
    };
  }

  function rechner(wurzel) {
    alle(wurzel, '[data-sbx-rechner]').forEach(function (r) {
      var breite = parseFloat(r.getAttribute('data-breite')) || 2.25;
      var qa = parseFloat(r.getAttribute('data-q-a')) || 72;
      var qb = parseFloat(r.getAttribute('data-q-b')) || 92;
      var tankEl = r.querySelector('[data-sbx-r-tank]');
      var tempoEl = r.querySelector('[data-sbx-r-tempo]');
      var druck = alle(r, '[data-sbx-r-druck]');
      var presets = alle(r, '[data-sbx-r-preset]');
      var aus = function (sel) { return r.querySelector(sel); };
      var setze = function (sel, txt) { var el = aus(sel); if (el) el.textContent = txt; };
      if (!tankEl || !tempoEl) return;
      var aktuell = { laenge: 0, lqm: 1 };

      function rechnen() {
        var tank = parseFloat(tankEl.value) || 1000;
        var tempo = parseFloat(tempoEl.value) || 3;
        var b = druck.filter(function (x) { return x.checked; })[0];
        var q = b && b.value === 'b' ? qb : qa;
        var mmin = tempo * 1000 / 60;
        var zeit = tank / q;
        var laenge = zeit * mmin;
        var flaeche = laenge * breite;
        var lqm = q / (mmin * breite);
        var skala = SKALA[SKALA.length - 1];
        for (var i = 0; i < SKALA.length; i++) { if (SKALA[i] >= Math.round(laenge)) { skala = SKALA[i]; break; } }
        var anteil = Math.min(1, laenge / skala);
        aktuell = { laenge: laenge, lqm: lqm };

        setze('[data-sbx-r-tank-out]', ganzFormat.format(tank));
        var tempoTxt = tempo % 1 === 0 ? ganzFormat.format(tempo) : einsFormat.format(tempo);
        setze('[data-sbx-r-tempo-out]', tempoTxt);
        setze('[data-sbx-r-laenge]', ganzFormat.format(Math.round(laenge)));
        setze('[data-sbx-r-zeit]', einsFormat.format(zeit));
        setze('[data-sbx-r-flaeche]', ganzFormat.format(Math.round(flaeche)));
        setze('[data-sbx-r-lqm]', zweiFormat.format(lqm));
        setze('[data-sbx-r-skala]', meter(skala));
        var balken = aus('[data-sbx-r-balken]'), fz = aus('[data-sbx-r-fahrzeug]');
        if (balken) balken.style.setProperty('--anteil', anteil.toFixed(4));
        if (fz) fz.style.setProperty('--anteil', anteil.toFixed(4));
        setze('[data-sbx-r-weg]', T('so_gerechnet') + ganzFormat.format(tank) + ' l ÷ ' + ganzFormat.format(q) + ' l/min = ' + einsFormat.format(zeit) + ' min · ' +
          einsFormat.format(zeit) + ' min × ' + ganzFormat.format(Math.round(mmin)) + ' m/min (' + tempoTxt + ' km/h) = ' + ganzFormat.format(Math.round(laenge)) + ' m · ' +
          ganzFormat.format(Math.round(laenge)) + ' m × ' + zweiFormat.format(breite) + ' m ' + T('spruehbreite') + ' = ' + ganzFormat.format(Math.round(flaeche)) + ' m²');
        presets.forEach(function (p) { p.setAttribute('aria-pressed', parseFloat(p.getAttribute('data-sbx-r-preset')) === tank ? 'true' : 'false'); });
        if (lb) lb.neu();
      }

      var lb = null;
      lb = luftbild(r, function () { return aktuell; });
      tankEl.addEventListener('input', rechnen);
      tempoEl.addEventListener('input', rechnen);
      druck.forEach(function (d) { d.addEventListener('change', rechnen); });
      presets.forEach(function (p) {
        p.addEventListener('click', function () {
          tankEl.value = p.getAttribute('data-sbx-r-preset');
          rechnen();
        });
      });
      rechnen();
    });
  }

  /* ---------- Handgriffe: Bühne folgt dem aktiven Schritt ---------- */

  function aufbau(wurzel) {
    alle(wurzel, '[data-sbx-aufbau]').forEach(function (a) {
      var schritte = alle(a, '[data-sbx-schritt]');
      var folien = alle(a, '[data-sbx-folie]');
      var uhr = a.querySelector('[data-sbx-uhr]');
      var nr = a.querySelector('[data-sbx-schritt-nr]');
      if (!schritte.length) return;
      var n = schritte.length;
      var aktiv = -1;
      function setzen(i) {
        if (i === aktiv) return;
        aktiv = i;
        schritte.forEach(function (s, k) { s.classList.toggle('ist-aktiv', k === i); s.classList.toggle('ist-erledigt', k < i); });
        folien.forEach(function (f) { f.classList.toggle('ist-aktiv', parseInt(f.getAttribute('data-sbx-folie'), 10) === i); });
        if (uhr) uhr.style.setProperty('--fortschritt', ((i + 1) / n).toFixed(3));
        if (nr) nr.textContent = String(i + 1);
      }
      setzen(0);
      var geplant = false;
      function pruefen() {
        geplant = false;
        var mitte = vh() * 0.5;
        var best = 0, abstand = Infinity;
        schritte.forEach(function (s, k) {
          var r = s.getBoundingClientRect();
          var d = Math.abs((r.top + r.bottom) / 2 - mitte);
          if (d < abstand) { abstand = d; best = k; }
        });
        setzen(best);
      }
      window.addEventListener('scroll', function () {
        if (geplant) return;
        geplant = true;
        requestAnimationFrame(pruefen);
      }, { passive: true });
      pruefen();
    });
  }

  /* ---------- Film erst auf Klick ---------- */

  function film(wurzel) {
    alle(wurzel, '[data-sbx-film]').forEach(function (f) {
      var id = f.getAttribute('data-sbx-film');
      var start = f.querySelector('[data-sbx-film-start]');
      if (!id || !start) return;
      start.addEventListener('click', function (e) {
        e.preventDefault();
        var ifr = document.createElement('iframe');
        var startSek = parseInt(f.getAttribute('data-sbx-start'), 10) || 0;
        ifr.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0&modestbranding=1' + (startSek > 0 ? '&start=' + startSek : '');
        ifr.title = T('film');
        ifr.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
        ifr.allowFullscreen = true;
        f.appendChild(ifr);
        start.remove();
      });
    });
  }

  /* ---------- Kaufleiste: erscheint, wenn der Kopf-Knopf aus dem Bild ist ---------- */

  function leiste() {
    var st = document.querySelector('[data-sbx-sticky]');
    if (!st || !hatIO) return;
    var kaufBereich = document.querySelector('[data-sbx-kauf]');
    var kaufZiel = kaufBereich && (kaufBereich.querySelector('[data-sbx-angebot]') || kaufBereich);
    var kontakt = document.getElementById('ContactForm');
    var fuss = document.querySelector('footer, .footer');
    var kaufSichtbar = true, kontaktSichtbar = false, fussSichtbar = false, tief = false;

    function pruefen() {
      var zeigen = tief && !kaufSichtbar && !kontaktSichtbar && !fussSichtbar;
      if (zeigen) {
        if (st.hidden) {
          st.hidden = false;
          requestAnimationFrame(function () { requestAnimationFrame(function () { st.classList.remove('ist-weg'); }); });
        } else st.classList.remove('ist-weg');
      } else if (!st.hidden) {
        st.classList.add('ist-weg');
      }
    }
    if (kaufZiel) new IntersectionObserver(function (e) { kaufSichtbar = e[0].isIntersecting; pruefen(); }).observe(kaufZiel);
    if (kontakt) new IntersectionObserver(function (e) { kontaktSichtbar = e[0].isIntersecting; pruefen(); }).observe(kontakt);
    if (fuss) new IntersectionObserver(function (e) { fussSichtbar = e[0].isIntersecting; pruefen(); }).observe(fuss);
    var messen = function () {
      var t = window.scrollY > 480;
      if (t !== tief) { tief = t; pruefen(); }
    };
    window.addEventListener('scroll', messen, { passive: true });
    messen();
  }

  /* ---------- Video-Loops: Quelle nach Breite, nur sichtbar, Vorschaubild bleibt Ruhezustand ---------- */

  function videoloops(wurzel) {
    var sparen = navigator.connection && navigator.connection.saveData;
    if (ruhig || sparen || !hatIO) return;
    var gross = window.matchMedia('(min-width: 990px)');
    alle(wurzel, '[data-sbx-videoloop]').forEach(function (box) {
      var v = box.querySelector('video');
      if (!v) return;
      var geladen = false;
      var laden = function () {
        if (geladen) return;
        geladen = true;
        v.src = gross.matches ? box.getAttribute('data-hoch') : box.getAttribute('data-quer');
        v.load();
      };
      v.addEventListener('playing', function () { box.classList.add('ist-an'); });
      beiSichtbar(box, function (an) {
        if (an) {
          laden();
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        } else if (geladen) {
          v.pause();
        }
      });
    });
  }

  /* ---------- Presse-Laufband: Tempo nach Breite, nur mit Bewegung ---------- */

  function laufband(wurzel) {
    if (ruhig) return;
    alle(wurzel, '[data-sbx-laufband]').forEach(function (b) {
      var satz = b.querySelector('.sbx-laufband__satz');
      if (!satz) return;
      b.classList.add('ist-lauf');
      var setzen = function () { b.style.setProperty('--sbx-dauer', Math.max(18, satz.scrollWidth / 42).toFixed(1) + 's'); };
      setzen();
      window.addEventListener('load', setzen);
    });
  }

  /* ---------- Start ---------- */

  function start() {
    var wurzel = document;
    stepper(wurzel);
    galerie(wurzel);
    kauf(wurzel);
    angebot(wurzel);
    anliegen(wurzel);
    zufuegen(wurzel);
    rechner(wurzel);
    aufbau(wurzel);
    film(wurzel);
    nebel(wurzel);
    videoloops(wurzel);
    laufband(wurzel);
    einblenden(wurzel);
    schleifen(wurzel);
    zaehlen(wurzel);
    leiste();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
